import { render, staticRenderFns } from "./CreateExtraOptionModal.vue?vue&type=template&id=c5247884&"
import script from "./CreateExtraOptionModal.vue?vue&type=script&lang=js&"
export * from "./CreateExtraOptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports